import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../features/counter/counterSlice'
import authReducer from '../features/auth/authSlice'
import accountReducer from '../features/accounts/accountSlice'
import proxyReducer from '../features/proxies/proxySlice'
import proxyUsageReducer from '../features/reports/proxy-usage/proxyUsageSlice'
import apiKeyReducer from '../features/apikeys/apikeySlice'
import systemConfigReducer from '../features/system-configs/systemConfigSlice'
import systemLogsReducer from '../features/system-logs/systemLogsSlice'
import yahooResponseReducer from '../features/yahoo-responses/yahooResponsesSlice'
import oidcReducer from '../features/oidc/oidcSlice'

const loggerMiddleware = (storeAPI: any) => (next: any) => (action: any) => {
	console.log('➡️ Dispatching:', action)
	const result = next(action)
	console.log('✅ Next state:', storeAPI.getState())
	return result
}

export const store = configureStore({
	reducer: {
		counter: counterReducer,
		auth: authReducer,
		account: accountReducer,
		proxy: proxyReducer,
		report_proxy_usage: proxyUsageReducer,
		api_key: apiKeyReducer,
		system_config: systemConfigReducer,
		system_log: systemLogsReducer,
		yahoo_response: yahooResponseReducer,
		oidc: oidcReducer,
	},
	middleware: (getDefaultMiddleware) => {
		let middlewares = []
		if (process.env.NODE_ENV !== 'production') {
			middlewares.push(loggerMiddleware)
		}
		return getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ['oidc/load_user', 'oidc/load_user/fulfilled'],
				ignoredPaths: ['oidc.user'],
			},
		}).concat(middlewares)
	},
})

// store.subscribe(() => {
// 	console.log('🧠 Redux state:', store.getState())
// })

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
